// extracted by mini-css-extract-plugin
export default {"Title":"StepperTitle_Title__+GQ6d"};